import { EngagementDetail } from '@anytag/graphql';
import { ProposalDerivedProps } from '../shared/types';
import { RejectedInfluencers } from './RejectedInfluencers';
import { SelectedInfluencers } from './SelectedInfluencers';
import { ProposalInfluencersDetailsModal } from './ProposalInfluencersDetailsModal';

interface ProposalInfluencersProps extends ProposalDerivedProps {
  engagement: EngagementDetail;
  hasTrackingReferral?: boolean;
  hasInfluencerCostPermission?: boolean;
}

export const ProposalInfluencers = ({
  jdMode,
  engagement,
  allInfluencers,
  hasTrackingReferral,
  selectedInfluencers,
  rejectedInfluencers,
  formattedInfluencers,
  formattedSocialAccounts,
  hasInfluencerCostPermission,
  formattedRejectedInfluencers
}: ProposalInfluencersProps) => (
  <>
    <SelectedInfluencers
      jdMode={jdMode}
      engagement={engagement}
      selectedInfluencers={selectedInfluencers}
      formattedInfluencers={formattedInfluencers}
      formattedSocialAccounts={formattedSocialAccounts}
      hasInfluencerCostPermission={hasInfluencerCostPermission}
      hasTrackingReferral={hasTrackingReferral}
    />

    {rejectedInfluencers.length > 0 ? (
      <RejectedInfluencers
        jdMode={jdMode}
        engagement={engagement}
        formattedRejectedInfluencers={formattedRejectedInfluencers}
        rejectedInfluencers={rejectedInfluencers}
        hasTrackingReferral={hasTrackingReferral}
        hasInfluencerCostPermission={hasInfluencerCostPermission}
      />
    ) : null}

    <ProposalInfluencersDetailsModal allInfluencers={allInfluencers} engagement={engagement} />
  </>
);
